/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ConfirmConfiguratioCard.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       :
 *
 * @Date          : 24 Oct 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : 24 Oct 2019
 * Description   : ASDS-1256. Moved reusable code from configure product file.
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3823 - Aspire UI enhancements of Phase-2
 *
 ******************************************************************************/
import * as React from 'react';
import ConfigureProductActions from '../redux/actions/configure-product-actions';
import { connect } from 'react-redux';
import {DisplaySCMCard} from '../ConfigureProduct/displaySCMCart';
import { ConfigSummary } from './configSummary';
import TotalPriceCard from '../ConfigureAPU/TotalPriceCard';

interface ConfirmFeatureProps{
    productSerialNumbers: any;
    gotoSCMSerialNumbersTab: Function;
    productFeatureMasterData: any;
    gotoConfigureFeaturesTab: Function;
    productFeatures: any;
    totalPrice: any;
}

class ConfirmConfiguration extends React.Component<ConfirmFeatureProps, any> {
render() {
    return (
        <React.Fragment>
               <DisplaySCMCard gotoSCMSerialNumbersTab={this.props.gotoSCMSerialNumbersTab} SCMSerialNumbers={this.props.productSerialNumbers} />
                <ConfigSummary gotoConfigureFeaturesTab={this.props.gotoConfigureFeaturesTab} productFeatures={ this.props.productFeatures} />
                <TotalPriceCard totalPrice={this.props.totalPrice} />

        </React.Fragment>

    );
}
}
const mapDispatchToProps = {
    gotoSCMSerialNumbersTab: ConfigureProductActions.gotoSCMSerialNumbersTab,
    gotoConfigureFeaturesTab: ConfigureProductActions.gotoConfigureFeaturesTab,
};

function mapStateToProps(state) {
    return{
    productFeatureMasterData: state.configProductData.payload.featuresMasterData,
    productFeatures: state.configProductData.payload.productFeatures,
    productSerialNumbers: state.configProductData.payload.serialNumbers,
    totalPrice: state.configProductData.payload.totalPrice,
    };
  }

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmConfiguration);
